import { render, staticRenderFns } from "./Module-card.vue?vue&type=template&id=3540f4f6&scoped=true"
import script from "./Module-card.vue?vue&type=script&lang=js"
export * from "./Module-card.vue?vue&type=script&lang=js"
import style0 from "./Module-card.vue?vue&type=style&index=0&id=3540f4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540f4f6",
  null
  
)

export default component.exports